// extracted by mini-css-extract-plugin
export default {"statusDiv":"task-tally_statusDiv__mvwkq","p":"task-tally_p__6QhZp","dot":"task-tally_dot__GNKxS","chipsIcon":"task-tally_chipsIcon__DIXW1"};